import { Grid } from '@material-ui/core'
import styled from 'styled-components'

export const FormFieldsContainer = styled(Grid)`
  overflow-y: auto;
  max-height: 66vh;
`
export const AnswersContainer = styled(Grid)`
  overflow-y: auto;
`
